import { render } from "./MessageHistory.vue?vue&type=template&id=45a9376a"
import script from "./MessageHistory.vue?vue&type=script&lang=js"
export * from "./MessageHistory.vue?vue&type=script&lang=js"
script.render = render

export default script